module.exports = __webpack_public_path__ + "img/buenos_aires_palermo.8bf83824.jpg";